exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redirect-modal input {\n  margin-bottom: 10px; }\n  .redirect-modal input::-moz-placeholder {\n    color: #bbbbbb;\n    font-style: italic; }\n  .redirect-modal input:-ms-input-placeholder {\n    color: #bbbbbb;\n    font-style: italic; }\n  .redirect-modal input::placeholder {\n    color: #bbbbbb;\n    font-style: italic; }\n", ""]);

// exports
